import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Sparkles, ArrowRight } from 'lucide-react'
import Card from './Card'
import Button from './Button'

const DemoUpgradePrompt = ({ featureName = 'this feature', limitReached = false }) => {
  const { t } = useTranslation()
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="mb-6"
    >
      <Card variant="soft" className={`p-6 bg-gradient-to-r from-primary-50 to-secondary-50 dark:from-primary-900/20 dark:to-secondary-900/20 border-2 ${limitReached ? 'border-red-300 dark:border-red-800' : 'border-primary-200 dark:border-primary-800'}`}>
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-primary-400 to-secondary-400 flex items-center justify-center flex-shrink-0">
            <Sparkles size={24} className="text-white" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2">
              {limitReached ? t('demo.demoModeLimitReached') : t('demo.demoMode')}
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-300 mb-4">
              {limitReached 
                ? t('demo.demoModeLimitDescription', { featureName })
                : t('demo.demoModeDescription', { featureName })
              }
            </p>
            <Link to="/onboarding">
              <Button className="w-full sm:w-auto">
                {t('demo.startFreeTrial')}
                <ArrowRight size={18} className="ml-2" />
              </Button>
            </Link>
          </div>
        </div>
      </Card>
    </motion.div>
  )
}

export default DemoUpgradePrompt

